
import { computed, ref, defineComponent } from "vue";

import * as Connection from "../src/connection";

import Page from "./a/page-component.vue";
import Card from "./a/card-component.vue";
import CardBody from "./a/card-body.vue";
import Btn from "./a/btn-component.vue";
import { useStore } from 'vuex'

export default defineComponent({
  components: {
    Page,
    Card,
    CardBody,
    Btn
  },
  setup() {

    const store=useStore();

    const isLoggedIn = computed(() => {
      return store.getters.isLoggedIn;
    });

    const loginStatus = computed(() => {
      return store.state.loginStatus
    });

    const serverName = ref( localStorage.getItem("serverName") || "localhost" );
    const serverPort = ref( parseInt( (localStorage.getItem("serverPort")  || 12345).toString() ) );
    const errMsg = ref( Connection.loginStatus.errMsg );

    const headrMsg= computed (()=> {
      if (isLoggedIn.value) {
        return loginStatus.value.serverName + ":" + loginStatus.value.serverPort;
      } else {
        if (errMsg.value) {
          return errMsg.value;
        }
        return "Not connected - try again";
      }
    })

  const doLogin=async ()=> {
    await Connection.login(serverName.value, serverPort.value);
    errMsg.value = Connection.loginStatus.errMsg;
    localStorage.setItem("serverName", serverName.value);
    localStorage.setItem("serverPort", serverPort.value.toString());
    store.commit("setLoginStatusRedirect", Connection.loginStatus);
  }

  const  doShutdown=async () => {
    Connection.connection.wcuserdata.applicationQuit();
    //Connection.loginStatus.isLoggedIn = false;
    store.commit("setLoginStatusRedirect", Connection.loginStatus);
  }

  const doLogout=async() => {
    await Connection.connection.close();
    //Connection.loginStatus.isLoggedIn = false;
    store.commit("setLoginStatusRedirect", Connection.loginStatus);
  }

  const doRestart=async() =>{
    await Connection.connection.wcmidiin.restart();
    await Connection.connection.wcmidiout.restart();
    doLogout();
  }

  return {doRestart,doLogout,doShutdown,doLogin,headrMsg,errMsg,
         serverPort,serverName,loginStatus,isLoggedIn }

  }
})


